import { render, staticRenderFns } from "./application-child-form.vue?vue&type=template&id=e896b438&"
import script from "./application-child-form.vue?vue&type=script&lang=js&"
export * from "./application-child-form.vue?vue&type=script&lang=js&"
import style0 from "./application-child-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports